module.exports = __webpack_public_path__ + "static/media/MuseoSansBold.b6a25a9b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansBold/MuseoSansBold.eot
// module id = 245
// module chunks = 0